<header>
  <nav class="navbar is-light">
    <div class="container">
      <div class="navbar-brand advertiser-branding">
        @if (corporateBrandOnly) {
          <a class="navbar-item corporate-brand" href="/" aria-label="FreeRateUpdate.com home">
            <img [src]="corporateLogoSrc" alt="FreeRateUpdate.com">
          </a>
        } @else {
          <div class="co-brand-lockup">
            @if (coBrandLogoSrc) {
              <img class="co-brand-logo" [src]="coBrandLogoSrc" [alt]="brandService.domain">
            }
            <span class="powered-by-lockup">
              <span class="powered-by">Powered by</span>
              <img [src]="corporateLogoSrc" alt="FreeRateUpdate.com">
            </span>
          </div>
        }
      </div>
      <div class="navbar-end">
        @if (officeStatus?.answer) {
          <div class="phone">
            <p class="has-text-grey-dark">or call for rates...</p>
            <p>
              <a href="tel:{{ officeStatus.phone }}" target="_blank">
                <i class="fas fa-phone"></i>
                {{ officeStatus.phonefancy }}
              </a>
            </p>
          </div>
        }
      </div>
    </div>
  </nav>
</header>
